import type { FeedbackBundle } from "@/lib/types";
/** Narrow only an already authorized/scrubbed bundle. This never grants access. */
export function feedbackForPlayer(
  bundle: FeedbackBundle | undefined,
  playerId: string | undefined,
): FeedbackBundle | undefined {
  if (!bundle || !playerId) return bundle;
  const player = bundle.players.find((p) => p.id === playerId);
  if (!player)
    return {
      ...bundle,
      players: [],
      notes: [],
      clips: [],
      playlists: [],
      match_summaries: [],
      goals: [],
      player_photo_requests: [],
    };
  const relevant = (row: { visibility: string; player_ids: string[] }) =>
    row.visibility === "team" || row.player_ids.includes(playerId);
  return {
    ...bundle,
    players: [player],
    notes: bundle.notes.filter(relevant),
    clips: bundle.clips.filter(relevant),
    playlists: bundle.playlists.filter(relevant),
    match_summaries: bundle.match_summaries,
    goals: bundle.goals.filter((g) => g.player_id === playerId),
    player_photo_requests: bundle.player_photo_requests?.filter(
      (p) => p.player_id === playerId,
    ),
  };
}
export function selectLinkedPlayer(
  bundle: FeedbackBundle | undefined,
  search: {
    player?: string;
    feedback_player_id?: string;
    note?: number;
    clip?: number;
    goal?: number;
    summary?: number;
  },
): string | undefined {
  const linked = bundle?.players ?? [];
  if (search.player)
    return linked.some((p) => p.id === search.player) ? search.player : undefined;
  if (search.feedback_player_id)
    return linked.some((p) => p.id === search.feedback_player_id) ? search.feedback_player_id : undefined;
  // A notification for another linked child's record selects that child when
  // the deep link carries no explicit context. Team-wide items keep the default.
  const target = search.note
    ? bundle?.notes.find((n) => n.id === search.note)
    : search.clip
      ? bundle?.clips.find((n) => n.id === search.clip)
      : null;
  const goal = search.goal
    ? bundle?.goals.find((g) => g.id === search.goal)
    : null;
  const ids = goal
    ? [goal.player_id]
    : target?.visibility !== "team"
      ? (target?.player_ids ?? [])
      : [];
  return linked.find((p) => ids.includes(p.id))?.id ?? linked[0]?.id;
}
